
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settlement",
      function () {
        return require("private-next-pages/settlement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settlement"])
      });
    }
  